import React, { useEffect, useState } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from 'react-router-dom';
import Preview from './Preview';
import { useMediaQuery } from 'react-responsive';

function DetailContent({ data }) {
  console.log('ini data template detail', data);

  const [questions, setQuestions] = useState([
    {
      questionText: '',
      questionType: 'radio',
      options: [{ optionText: '' }],
      answer: false,
      answerKey: '',
      points: 0,
      open: true,
      required: false,
    },
  ]);

  const [templateName, setTemplateName] = useState('Untitled template');
  const [docName, setDocName] = useState('Untitled Document');
  const [docDesc, setDocDesc] = useState('Add Description');
  const [templateType, setTemplateType] = useState('');
  const [imgUrl, setImgUrl] = useState('');

  const router = useHistory();

  useEffect(() => {
    async function data_adding() {
      console.log('ini DATA FORM BUILDER,', data);
      let nameDoc = data.docName;
      let descDoc = data.docDesc;
      let templateName = data.templateName;
      let templateType = data.type;
      let selectedFile = data.selectedFile;
      setDocName(nameDoc);
      setDocDesc(descDoc);
      setTemplateName(templateName);
      setTemplateType(templateType);
      setImgUrl(selectedFile);
      setQuestions(data.questions);
      console.log('ini nameDoc,', nameDoc);
    }

    data_adding();
  }, []);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  console.log('ini questions template detail', questions);

  return (
    <>
      <Desktop>
        <div className='sm:grid-cols-1 grid sm:gap-7 gap-3 mt-6'>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
            <div className='px-4 bg-white flex-col justify-center items-center rounded '>
              <div className='hidden col-span-2 lg:flex bg-white-500  w-full'>
                <div className='z-0  w-full'>
                  <div className='sm:grid-cols-3 grid sm:gap-7 gap-3 mt-6'>
                    <div className='col-span-2 bg-white overflow-hidden border rounded-lg px-4 py-4'>
                      <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                        <div>
                          <div className='bg-white-500 shadow-md p-5 rounded-md mb-5'>
                            <p className='outline-none w-full text-lg mb-3'>
                              {docName}
                            </p>
                            <p className='outline-none w-full text-xs'>
                              {docDesc}
                            </p>
                          </div>
                          <Preview
                            docName={docName}
                            docDesc={docDesc}
                            allQuest={questions}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='bg-white overflow-hidden border rounded-lg px-4 py-4'>
                      <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                        <img src={imgUrl} className='rounded' />
                        <div className='mt-3'>
                          <p className=''>Template name</p>
                          <p className='font-bold ml-3'>{templateName}</p>
                        </div>
                        <div className='mt-3'>
                          <p className=''>Template type</p>
                          <p className='font-bold ml-3'>{templateType}</p>
                        </div>
                        <div className='mt-3'>
                          <p className=''>Total questions</p>
                          <p className='font-bold ml-3'>{questions.length}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Desktop>
      <Tablet>
        <div className='sm:grid-cols-1 grid sm:gap-2 gap-1 mt-6'>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-1 py-4'>
            <div className='px-1 bg-white flex-col justify-center items-center rounded '>
              <div className=' col-span-2 lg:flex bg-white-500  w-full'>
                <div className='z-0  w-full'>
                  <div className='sm:grid-cols-3 grid sm:gap-2 gap-1 mt-6'>
                    <div className='col-span-2 bg-white overflow-hidden border rounded-lg px-1 py-4'>
                      <div className='px-2 bg-white flex-col justify-center items-center rounded'>
                        <div>
                          <div className='bg-white-500 shadow-md p-5 rounded-md mb-5'>
                            <p className='outline-none w-full text-lg mb-3'>
                              {docName}
                            </p>
                            <p className='outline-none w-full text-xs'>
                              {docDesc}
                            </p>
                          </div>
                          <Preview
                            docName={docName}
                            docDesc={docDesc}
                            allQuest={questions}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='bg-white overflow-hidden border rounded-lg px-1 py-4'>
                      <div className='px-1 bg-white flex-col justify-center items-center rounded'>
                        <img src={imgUrl} className='rounded' />
                        <div className='mt-3'>
                          <p className=''>Template name</p>
                          <p className='font-bold ml-3'>{templateName}</p>
                        </div>
                        <div className='mt-3'>
                          <p className=''>Template type</p>
                          <p className='font-bold ml-3'>{templateType}</p>
                        </div>
                        <div className='mt-3'>
                          <p className=''>Total questions</p>
                          <p className='font-bold ml-3'>{questions.length}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tablet>
      <Mobile>
        <div className='sm:grid-cols-1 grid sm:gap-2 gap-1 mt-2'>
          <div className='bg-white overflow-hidden shadow-md rounded-lg px-1 py-4'>
            <div className='px-1 bg-white flex-col justify-center items-center rounded '>
              <div className=' col-span-2 lg:flex bg-white-500  w-full'>
                <div className='z-0  w-full'>
                  <div className='bg-gray-400 border rounded-lg px-4 py-2 font-bold mt-3'>
                    <p className='text-white'>About</p>
                  </div>
                  <div className='bg-white overflow-hidden border rounded-lg px-1 py-4'>
                    <div className='px-1 bg-white flex-col justify-center items-center rounded'>
                      <img src={imgUrl} className='rounded h-32 w-full object-cover' alt='template' />
                      <div className='mt-3'>
                        <p className=''>Template name</p>
                        <p className='font-bold ml-3'>{templateName}</p>
                      </div>
                      <div className='mt-3'>
                        <p className=''>Template type</p>
                        <p className='font-bold ml-3'>{templateType}</p>
                      </div>
                      <div className='mt-3'>
                        <p className=''>Total questions</p>
                        <p className='font-bold ml-3'>{questions.length}</p>
                      </div>
                    </div>
                  </div>
                  <div className='bg-gray-400 border rounded-lg px-4 py-2 font-bold mt-3'>
                    <p className='text-white'>Preview</p>
                  </div>
                  <div className='col-span-2 bg-white overflow-hidden border rounded-lg px-1 py-4'>
                    <div className='px-2 bg-white flex-col justify-center items-center rounded'>
                      <div>
                        <div className='bg-white-500 shadow-md p-5 rounded-md mb-5'>
                          <p className='outline-none w-full text-lg mb-3'>
                            {docName}
                          </p>
                          <p className='outline-none w-full text-xs'>
                            {docDesc}
                          </p>
                        </div>
                        <Preview
                          docName={docName}
                          docDesc={docDesc}
                          allQuest={questions}
                        />
                      </div>
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Mobile>
    </>
  );
}

export default DetailContent;
